import { HEADER_LOGO, RECURRING_MODEL_CHECK, SET_RECURRING_MODEL_CHECK, SET_SELECTED_BATCH_ID, MODAL_CLOSE_VALUE } from "../constants/index";
export const HeaderLogo = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: HEADER_LOGO, payload: payload });
  });
};

export const RecurringModelCheck = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: RECURRING_MODEL_CHECK, payload: payload });
  });
};

export const SetRecurringChecks = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: SET_RECURRING_MODEL_CHECK, payload: payload });
  });
};

export const SetSelectedBatchId = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: SET_SELECTED_BATCH_ID, payload: payload });
  });
};

export const ModalCloseValue = (payload) => (dispatch) => {
  return new Promise(() => {
    dispatch({ type: MODAL_CLOSE_VALUE, payload: payload });
  });
};
